import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import { Tooltip } from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';
import Loader from 'app/components/general/Loader';

export default class IconButton extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    block: PropTypes.bool,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    outline: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    getRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onClick: PropTypes.func,
    size: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string.isRequired,
    cssModule: PropTypes.object,
    icon: PropTypes.string,
    to: PropTypes.string,
    tooltipText: PropTypes.string,
    id: PropTypes.string,
  };

  static defaultProps = {
    color: 'secondary',
    tag: 'button',
    icon: undefined,
    active: undefined,
    block: undefined,
    disabled: undefined,
    outline: undefined,
    getRef: undefined,
    onClick: undefined,
    size: undefined,
    cssModule: undefined,
    children: undefined,
    to: undefined,
    tooltipText: undefined,
    id: undefined,
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  state = {
    tooltipOpen: false,
  };

  onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  toggleTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };

  render(): React.ReactNode {
    const clonedProps = { ...this.props };
    delete clonedProps.tooltipText;
    const {
      active,
      block,
      className,
      cssModule,
      color,
      outline,
      size,
      tag: Tag,
      getRef,
      to,
      ...attributes
    } = clonedProps;
    if (to === undefined) {
      return (
        <div>
          <button
            to={to}
            onClick={this.onClick}
            className={classnames(this.props.className, {
              'is-loading': this.props.isLoading,
            })}
            id={this.props.id}
            {...attributes}
          >
            <Loader isActive={this.props.isLoading} />
            {' '}
            <span
              className={classnames('align-middle', {
                'btn-transparent-text':
                  this.props.centerloader && this.props.isLoading,
              })}
            >
              {!this.props.isLoading ? (
                <div>
                  <Isvg className="align-middle" src={this.props.icon} />
                  <span className="align-middle icon-button-text">
                    {this.props.children}
                  </span>
                </div>
              ) : null}
            </span>
          </button>
          {!_.isEmpty(this.props.tooltipText) && (
            <Tooltip
              placement="right"
              isOpen={this.state.tooltipOpen}
              target={this.props.id}
              toggle={this.toggleTooltip}
            >
              {this.props.tooltipText}
            </Tooltip>
          )}
        </div>
      );
    }
    return (
      <div>
        <Link
          id={this.props.id}
          to={to}
          onClick={this.onClick}
          className={this.props.className}
          {...attributes}
        >
          <Isvg className="align-middle" src={this.props.icon} />
          <span className="align-middle icon-button-text">
            {this.props.children}
          </span>
        </Link>
        {!_.isEmpty(this.props.tooltipText)
          && (
            <Tooltip
              placement="right"
              isOpen={this.state.tooltipOpen}
              target={this.props.id}
              toggle={this.toggleTooltip}
            >
              {this.props.tooltipText}
            </Tooltip>
          )}
      </div>
    );
  }
}
